export default __webpack_public_path__ + "static/media/gp.88ac9533.jpg";